import { isFunction, isObject } from 'lodash'

export default function parseChild(is, props) {
  let children = is
  if (isFunction(children)) {
    children = children({ props })
  } else if (isObject(children)) {
    children = (
      <children {...props} />
    )
  } else if (typeof children === 'string') {
    const slotFn = props.propScopedSlots[children]
    if (slotFn) {
      children = slotFn(props)
    } else {
      throw new Error(`failed to lookup named slot under table ${children}`)
    }
  }
  if (!children) {
    const { cellData } = props
    // 只有数据为未定义才展示 -,避免 0,false,'' 等情况显示 - 的问题
    children = (cellData === undefined || cellData === null) ? '-' : cellData
  }
  return children
}
